import { StatusBadge } from "@/components/wheel/StatusBadge";
import { CockpitPanel, useCockpitAdmin } from "@/cockpit/CockpitPanel";

const BADGE = {
  "Strong Bullish": { color: "#10B981", label: "Strong bull" },
  Bullish: { color: "#34D399", label: "Bullish" },
  Neutral: { color: "var(--hoip-text-secondary)", label: "Neutral" },
  Bearish: { color: "#F87171", label: "Bearish" },
  "Strong Bearish": { color: "#EF4444", label: "Strong bear" },
};

export function SentimentFeedTable({ feed, houseFeed }) {
  const isAdmin = useCockpitAdmin();
  const rows = feed || [];
  const showImpact = !houseFeed && rows.some((r) => r.impactScore != null);
  return (
    <CockpitPanel
      title="Headlines"
      hint={houseFeed
        ? "Tone is a keyword tag on the FinancialData.net headline, or a vendor sentiment field if present. Not a SentiSense score."
        : "Impact vector is a mock score. Not live SentiSense and not a trade recommendation."}
      badge={isAdmin ? (
        <StatusBadge
          tier="info"
          text="Headline tags"
          title={houseFeed
            ? "Tone is a keyword tag on the FinancialData.net headline, or a vendor sentiment field if present. Not a SentiSense score."
            : "Impact vector is a mock score. Not live SentiSense and not a trade recommendation."}
        />
      ) : null}
      testid="sentiment-feed-table"
    >
      {rows.length === 0 ? (
        <div className="text-[11px]" style={{ color: "var(--hoip-text-tertiary)" }}>No headlines in this view yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-[11px]">
            <thead>
              <tr style={{ color: "var(--hoip-text-tertiary)" }}>
                <th className="text-left py-1.5">Date</th>
                <th className="text-left">Tone</th>
                {showImpact ? <th className="text-right">Impact</th> : null}
                {showImpact ? <th className="text-right">Cluster</th> : null}
                <th className="text-left px-3">Headline</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const b = BADGE[r.sentimentBadge] || BADGE.Neutral;
                const d = String(r.timestamp || "").slice(0, 10);
                const impact = Number(r.impactScore);
                const dir = r.sentimentBadge === "Bearish" || r.sentimentBadge === "Strong Bearish" ? "▼ " : r.sentimentBadge === "Neutral" ? "● " : "▲ ";
                return (
                  <tr key={r.id} className="border-t" style={{ borderColor: "var(--hoip-divider)" }}>
                    <td className="py-1.5 font-mono-data whitespace-nowrap">{d}</td>
                    <td>
                      <span className="text-[9px] px-1.5 py-0.5 rounded-sm" style={{ color: b.color, border: `1px solid ${b.color}44` }}>
                        {dir}{b.label}
                      </span>
                    </td>
                    {showImpact ? (
                      <td className="text-right font-mono-data" style={{ color: impact >= 0 ? "#34D399" : "#F87171" }}>
                        {Number.isFinite(impact) ? `${impact > 0 ? "+" : ""}${impact.toFixed(2)}` : "—"}
                      </td>
                    ) : null}
                    {showImpact ? (
                      <td className="text-right font-mono-data">{r.clusterSize ?? "—"}</td>
                    ) : null}
                    <td className="px-3 py-1.5">
                      {r.url ? (
                        <a href={r.url} className="hover:underline" style={{ color: "var(--hoip-text-primary)" }} title={r.headline}>{r.headline}</a>
                      ) : (
                        <span title={r.headline}>{r.headline}</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </CockpitPanel>
  );
}
